import { render, staticRenderFns } from "./calendar.vue?vue&type=template&id=2732cc3e&"
import script from "./calendar.vue?vue&type=script&lang=ts&"
export * from "./calendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports